import { Address } from '@adornis/address/db/address.js';
import type { InvoiceManagementPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { BHFilter } from '@adornis/buchungsheld-db/entities/bh-filter.js';
import { dataviewEmptyState } from '@adornis/buchungsheld-db/global-helpers.js';
import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { ColumnDefinition } from '@adornis/data-view/ColumnDefinition.js';
import { View } from '@adornis/data-view/db/view.js';
import '@adornis/internationalization/client/x-tel-input.js';
import { html, nothing } from 'lit';
import { of } from 'rxjs';
import type { IKHStammdaten } from '../stammdaten/ikh-stammdaten-plugin.js';

export const ikhInvoiceManagementPlugin: InvoiceManagementPlugin<IKHStammdaten> = {
  id: 'invoice-management::ikh',
  type: 'invoice-management',
  render: (stammdaten: IKHStammdaten, scope: ChemistryLitElement) => {
    return html`
      <x-flex space="md">
        <tr-h3> Rechnungsadressen </tr-h3>
        <tr-data-view
          .coloring=${scope.colors.accent}
          .options=${{
            class: Address,
            operation: () => () => of([stammdaten.address /* ToDo: spread with other available address */]),
            isSortable: true,
            isEntryClickable: false,
            emptyState: () => dataviewEmptyState({}),
            view: new View({ filter: new BHFilter({}) }),
            customColumns: [
              {
                customID: 'typeIcon',
                columnWidth: '3ch',
                renderHeader: _ => nothing,
                renderItem: instance => html` <tr-icon ${css({ fontSize: `${scope.baseFontSize}px` })}>home</tr-icon> `,
              },
              {
                customID: 'art',
                columnName: 'Rechn.Art',
                columnWidth: 'min-content',
                renderItem: instance => html` <tr-text ${css({ textWrap: 'nowrap' })}>GU internet</tr-text> `,
              },
              { fieldName: 'zipCity.zip', columnName: 'ZIP-Code', columnWidth: '7ch' },
              { fieldName: 'zipCity.city', columnName: 'Stadt' },
              { fieldName: 'streetAndHousenumber', columnName: 'Straße' },
              // {
              //   customID: 'viewBtn',
              //   columnWidth: 'min-content',
              //   renderHeader: _ => html`
              //     <x-flex
              //       space="xs"
              //       horizontal
              //       center
              //       crossaxis-center
              //       w100
              //       ${acss({
              //         color: scope.colors.accent.shade(800),
              //         'tr-icon': { fontSize: `${scope.baseFontSize}px` },
              //         'tr-text': { textWrap: 'nowrap' },
              //       })}
              //     >
              //       <tr-icon>electric_bolt</tr-icon>
              //       <tr-text bold>Aktionen</tr-text>
              //     </x-flex>
              //   `,
              //   renderItem: instance => html`
              //     <x-flex space="xs" horizontal>
              //       <tr-button-small
              //         icon="visibility"
              //         .color=${scope.colors.accent.shade(600)}
              //         @click=${() => 0}
              //       ></tr-button-small>

              //       <tr-button-small
              //         icon="edit"
              //         .color=${scope.colors.accent.shade(600)}
              //         @click=${() => 0}
              //       ></tr-button-small>

              //       <tr-button-small
              //         icon="delete"
              //         .color=${scope.colors.accent.shade(600)}
              //         @click=${() => 0}
              //       ></tr-button-small>
              //     </x-flex>
              //   `,
              // },
            ] as Array<ColumnDefinition<any>>,
          }}
        ></tr-data-view>
      </x-flex>
    `;
  },
};
